import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Advance } from 'src/model/advance.modal';
import { User } from 'src/model/user.model';
import { UserService } from 'src/services/user.service';

@Component({
    selector: 'app-add-advance',
    templateUrl: './add-advance.component.html',
    styleUrls: ['./add-advance.component.scss'],
    standalone: false
})
export class AddAdvanceComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);
  private userService = inject(UserService);

  @Input() companyAccountList: Account[] = [];

  selectedAccountId: number;
  selectedUser: string;
  loggedInCompanyId: number;

  @Output() passEntry = new EventEmitter<any>();
  //2-WAY BINDING INFO
  date: Date;
  remark: string;
  amount = 0;
  userList: User[] = [];

  disabledSubmit = false;

  constructor() {
    this.date = new Date();
  }

  ngOnInit(): void {
    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));

    this.getAllUsersOfCompany();
    this.getAllAccountsOfCompany(this.loggedInCompanyId);
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          const loggedInUsername = sessionStorage.getItem("username");
          if (json.username == loggedInUsername || json.username == undefined)
            this.companyAccountList.push(account);
        });
      }
    };
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  setSelectedUser(username: string) {
    if (username === this.selectedUser)
      return true
    else
      return false;
  }

  private async getAllUsersOfCompany() {
    this.userList = await this.userService.getAllUsers();
  }

  isBalanceInsufficient(balance: number) {
    if (balance > this.amount)
      return false;
    else
      return true;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined)
    const selectedUserNull = (this.selectedUser == undefined);
    const paymentValid = (isNaN(+this.amount))

    return paymentNull || remarkNull || selectedAccountIdNull || selectedUserNull || paymentValid;
  }

  addAdvance() {
    this.disabledSubmit = true;

    const isoTaskDate = (new Date(Number(this.date))).toISOString();

    const positiveAmount = (this.amount < 0) ? -this.amount : this.amount;
    const data = {
      "amount": positiveAmount,
      "accountId": Number(this.selectedAccountId),
      "dateCreated": isoTaskDate,
      "remark": this.remark,
      "username": this.selectedUser
    };

    let xhr;
    if (this.amount < 0)
      xhr = this.restapi.postRequest(this.constructApi.getAddAdvanceDeposit(), data);
    else
      xhr = this.restapi.postRequest(this.constructApi.getAddAdvanceBorrow(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.disabledSubmit = false;
          // var json = JSON.parse(xhr.responseText);

          // let account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
          // this.passEntry.emit(account)

          const advance = new Advance(null, this.selectedUser, this.date, -this.amount, this.remark)
          this.passEntry.emit(advance);
          this.reset();
          this.sharedService.openAlert("Successfully added advance!", ALERT_TYPE.SUCCESS);
        }
        else {
          this.disabledSubmit = false;
          this.sharedService.openAlert("Opps,some error occured. Please try again later", ALERT_TYPE.DANGER);
        }
      }
    }
  }

  submit() {
    (this.isFieldNull()) ? this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER) : this.addAdvance();
  }

  reset() {
    this.activeModal.close();
  }
}
